import { render, staticRenderFns } from "./SelfAssessmentSpeedTest.vue?vue&type=template&id=52e9d470&scoped=true&"
import script from "./SelfAssessmentSpeedTest.vue?vue&type=script&lang=ts&"
export * from "./SelfAssessmentSpeedTest.vue?vue&type=script&lang=ts&"
import style0 from "./SelfAssessmentSpeedTest.vue?vue&type=style&index=0&id=52e9d470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e9d470",
  null
  
)

export default component.exports